import React from 'react';
import { NguonKhachHangRow } from './NguonKhachHangRow';

export const ContentTable = ({ listNguonKH, dbName, onReload, onDelete, onDataChanged}) => {
    
    if (!listNguonKH || listNguonKH.length === 0) {
        return (
            <div className="custom-table-row no-data" style={{ minHeight: 56, justifyContent: 'center' }}>
                <p>Không có dữ liệu</p>
            </div>
        );
    }
    return (
        <>
            {listNguonKH.map((item) => (
                <NguonKhachHangRow
                    key={item.NguonKH_ID}
                    item={item}
                    dbName={dbName}
                    onReload={onReload}
                    onDelete={onDelete}
                    onDataChanged={onDataChanged}
                />
            ))}
        </>
    );
};